const navigation = function() {
  $(".js-dropdown-toggle").on("click", function(e) {
    e.preventDefault();

    if (!$(this).hasClass(".js-megamenu-toggle")) {
      $(".js-megamenu")
        .slideUp("fast")
        .removeClass("is--open");
    }

    if ($(this).hasClass("is--open")) {
      $(this)
        .parent()
        .find(".js-dropdown")
        .slideUp("fast");
      $(this).removeClass("is--open");
    } else {
      $(".js-dropdown-toggle.is--open")
        .removeClass("is--open")
        .parent()
        .find(".js-dropdown")
        .slideToggle("fast");

      $(this)
        .parent()
        .find(".js-dropdown")
        .slideDown("fast");
      $(this).addClass("is--open");
    }
  });

  $(".js-megamenu-toggle").on("click", function(e) {
    e.preventDefault();

    var megamenu = $(".js-megamenu#" + $(this).data("megamenu-id"));

    $(".js-megamenu")
      .not(".js-megamenu#" + $(this).data("megamenu-id"))
      .hide()
      .removeClass("is--open");

    if (megamenu.hasClass("is--open")) {
      megamenu.slideUp("fast").removeClass("is--open");
    } else {
      megamenu.slideDown("fast").addClass("is--open");

      console.log($(".js-megamenu-main").first());
      // show first megamenu item
      megamenu
        .find(".js-megamenu-main")
        .first()
        .fadeIn();
    }
  });

  $(".js-megamenu-main").hide();
  $(".js-megamenu-main-link").on("mouseover", function(e) {
    $(".js-megamenu-main").hide();
    $(".js-megamenu-main#" + $(this).data("child-id")).fadeIn();
  });

  $(".js-navigation").on("show.bs.collapse", function() {
    $("body").addClass("no--scroll");
    $(".js-header-toggler").addClass("is-active");
  });

  $(".js-navigation").on("hide.bs.collapse", function() {
    $("body").removeClass("no--scroll");
    $(".js-header-toggler").removeClass("is-active");
  });

  //

  var lastScrollTop = 0;
  $(window).on("scroll", function() {
    const st = $(this).scrollTop();
    if (st < lastScrollTop) {
      $(".js-header").removeClass("is--white");
    } else if ($(document).scrollTop() > 200) {
      $(".js-header").addClass("is--white");
    }
    lastScrollTop = st;
  });

  $(document).mouseup(function(e) {
    var container = $(".js-megamenu");
    var header = $(".js-header");

    // if the target of the click isn't the container nor a descendant of the container
    if (
      !container.is(e.target) &&
      container.has(e.target).length === 0 &&
      !header.is(e.target) &&
      header.has(e.target).length === 0
    ) {
      container.slideUp("fast");
      container.removeClass("is--open");
    }
  });

  $(document).mouseup(function(e) {
    var container = $(".js-dropdown");
    var toggler = $(".js-dropdown-toggle");

    // if the target of the click isn't the container nor a descendant of the container
    if (
      !container.is(e.target) &&
      container.has(e.target).length === 0 &&
      !toggler.is(e.target) &&
      toggler.has(e.target).length === 0 &&
      $(window).width() > 991
    ) {
      $(".js-dropdown-toggle.is--open")
        .removeClass("is--open")
        .parent()
        .find(".js-dropdown")
        .slideToggle("fast");
    }
  });
};

export default navigation;
